/*
  La Famille Tremblay - duidelijker winkelmandje voor 50+ klanten (Québec)
  - Eenvoudige kortingsbalk ("✓ 20 % de rabais appliqué")
  - Eén prijsnotatie: 69,95 $
  - Gratis foulard als "OFFERT" met kleurkeuze in het mandje
  - Overzicht: sous-total, rabais, livraison gratuite, total + "Vous économisez"
  - Vertrouwensregel onder de betaalknop
  Laadt na cart-drawer.js en lft-cart-extras.js.

  Mobiel (<=767px): rustigere, compactere weergave van dezelfde informatie
  (geen aparte stappenlijst, kortingsregel zonder "(N article(s))", bespaarregel
  als klein tekstregeltje i.p.v. los blok, vertrouwensregel in 1 compacte rij).
  Desktop blijft volledig ongewijzigd qua inhoud en opmaak.
*/
(function () {
  if (typeof CartDrawerController === 'undefined') return;

  var P = CartDrawerController.prototype;
  var ROOT = (window.Shopify && window.Shopify.routes && window.Shopify.routes.root) || '/';
  var GIFT_ID = 15712408142089;
  var GIFT_HANDLE = 'large-cashmere-feel-scarf-shawls-solid-colors';
  var TIERS = [{ qty: 1, pct: 10 }, { qty: 2, pct: 15 }, { qty: 3, pct: 20 }, { qty: 4, pct: 25 }];

  var css = document.createElement('style');
  css.textContent = [
    '.cart-drawer__eyebrow{display:none!important}',
    '.cart-drawer__title [data-cart-drawer-count]{display:none}',
    '.lftx-count{font-size:15px;font-weight:500;color:#555}',
    '.cart-tier.lftx-tier{background:#f6f1e9;border-radius:10px;padding:14px 14px 12px;margin-top:10px;text-align:left}',
    '.lftx-tier .lftx-big{display:block;font-size:18px;font-weight:700;color:#1d6b3a;margin:0 0 4px}',
    '.lftx-tier .lftx-msg{margin:0;font-size:15px;color:#222;line-height:1.35}',
    '.lftx-track{height:10px;background:#ddd;border-radius:6px;margin:10px 0 6px;overflow:hidden}',
    '.lftx-track div{height:100%;background:#1d6b3a}',
    '.lftx-steps{display:flex;justify-content:space-between;font-size:14px;color:#222;font-weight:600;list-style:none;margin:0;padding:0}',
    '.lftx-steps li.off{color:#777;font-weight:500}',
    '.cart-drawer__item-title{font-size:15px}',
    '.cart-drawer__item-variant{font-size:14px;color:#444}',
    '.lftx-gift-badge{display:inline-block;background:#1d6b3a;color:#fff;font-weight:700;font-size:14px;padding:3px 8px;border-radius:4px;white-space:nowrap}',
    '.lftx-gift-note{font-size:14px;color:#444;margin-top:4px;line-height:1.4}',
    '.lftx-gift-note select,.lftx-gift-offer select{font-size:14px;padding:4px;margin-left:4px}',
    '.lft-gift-offer.lftx-gift-offer{background:#e8f4ec;border:1px solid #bfdcc8;border-radius:8px;padding:10px 12px;font-size:15px;color:#1d3b28}',
    '.lftx-gift-offer button{margin-top:8px;width:100%;background:#1d6b3a;color:#fff;border:0;border-radius:6px;padding:10px;font-weight:700;font-size:15px;cursor:pointer}',
    '.cart-drawer__summary > :not(.lftx-sum){display:none!important}',
    '.lftx-row{display:flex;justify-content:space-between;font-size:15px;margin:2px 0;color:#222}',
    '.lftx-row.lftx-disc{color:#1d6b3a;font-weight:600}',
    '.lftx-row .lftx-free{color:#1d6b3a;font-weight:600}',
    '.lftx-row.lftx-total{font-size:19px;font-weight:700;margin-top:4px}',
    '.lftx-save{background:#e8f4ec;color:#1d6b3a;font-weight:700;text-align:center;border-radius:8px;padding:6px;margin:6px 0 8px;font-size:15px}',
    '.cart-drawer__checkout-button{font-size:17px!important}',
    '.lftx-trust{display:flex;justify-content:space-around;text-align:center;font-size:12px;color:#333;margin-top:8px;line-height:1.3}',
    '.lftx-trust div{flex:1}',
    '.lftx-trust span{display:block;font-size:16px}',
    '.lftx-trust .lftx-trust-mobile{display:none}',
    '@media (max-width:767px){' +
      '.lftx-tier.lftx-tier{padding:10px 12px 9px;border-radius:8px}' +
      '.lftx-tier .lftx-big{font-size:14.5px;margin:0 0 2px}' +
      '.lftx-tier .lftx-msg{font-size:13.5px;line-height:1.35}' +
      '.lftx-track{height:5px;margin:8px 0 0}' +
      '.lftx-steps{display:none}' +
      '.lftx-count-detail{display:none}' +
      '.lftx-save{background:none;color:#1d6b3a;text-align:left;padding:2px 0 0;margin:2px 0 0;font-size:12.5px;font-weight:600;border-radius:0}' +
      '.lftx-row{font-size:13.5px}' +
      '.lftx-row.lftx-total{font-size:17px;border-top:1px solid rgba(0,0,0,.08);padding-top:6px;margin-top:6px}' +
      '.lftx-trust{justify-content:center;gap:16px;flex-wrap:wrap;font-size:11.5px;margin-top:6px;padding:0 4px}' +
      '.lftx-trust div{flex:none}' +
      '.lftx-trust .lftx-trust-desktop{display:none}' +
      '.lftx-trust .lftx-trust-mobile{display:inline}' +
    '}'
  ].join('');
  document.head.appendChild(css);

  function money(cents) {
    return ((Number(cents) || 0) / 100).toFixed(2).replace('.', ',') + ' $';
  }

  // Overal dezelfde notatie: 69,95 $
  P.formatMoney = function (cents) { return money(cents); };

  P.lftxPaid = function (cart) {
    if (this.lftPaidQuantity) return this.lftPaidQuantity(cart);
    return (cart.items || []).reduce(function (s, i) {
      return s + (Number(i.product_id) !== GIFT_ID && Number(i.original_price || i.price) > 0 ? i.quantity : 0);
    }, 0);
  };

  P.lftRenderTier = function (node, cart) {
    var paid = this.lftxPaid(cart);
    if (!paid) { node.hidden = true; node.innerHTML = ''; return; }
    node.classList.add('lftx-tier');
    var step = TIERS.filter(function (t) { return paid >= t.qty; }).pop();
    var next = TIERS.find(function (t) { return paid < t.qty; });
    var msg;
    if (!next) {
      msg = 'C’est le rabais maximal. Bravo!';
    } else {
      var extra = next.qty - paid;
      msg = 'Ajoutez <b>' + extra + ' article' + (extra > 1 ? 's' : '') + ' de plus</b> et obtenez <b>' +
        next.pct + ' % de rabais</b>' + (next.qty === 3 ? ' + <b>un foulard offert 🎁</b>' : ' sur toute la commande') + '.';
    }
    var steps = TIERS.map(function (t) {
      return '<li class="' + (paid >= t.qty ? '' : 'off') + '">' + t.qty + ' art. ' + t.pct + ' %</li>';
    }).join('');
    node.innerHTML =
      '<p class="lftx-big">✓ ' + step.pct + ' % de rabais appliqué</p>' +
      '<p class="lftx-msg">' + msg + '</p>' +
      '<div class="lftx-track"><div style="width:' + Math.min(paid / 4, 1) * 100 + '%"></div></div>' +
      '<ol class="lftx-steps">' + steps + '</ol>';
    node.hidden = false;
  };

  P.lftRenderDiscount = function (node, cart) {
    if (node) node.hidden = true;
    var summary = this.drawer.querySelector('.cart-drawer__summary');
    if (!summary) return;
    var box = summary.querySelector('.lftx-sum');
    if (!box) {
      box = document.createElement('div');
      box.className = 'lftx-sum';
      summary.appendChild(box);
    }
    var paid = this.lftxPaid(cart);
    var before = Number(cart.original_total_price || 0);
    var total = Number(cart.total_price || 0);
    var disc = Math.max(0, before - total);
    var step = TIERS.filter(function (t) { return paid >= t.qty; }).pop();
    var self = this;
    var compare = (cart.items || []).reduce(function (s, i) {
      if (Number(i.product_id) === GIFT_ID) return s;
      var c = Number((self.variantCompareAtPrices && self.variantCompareAtPrices.get(Number(i.variant_id))) || 0);
      var unit = Math.max(c, Number(i.original_price || i.price || 0));
      return s + unit * Number(i.quantity || 0);
    }, 0);
    var save = compare - total;
    box.innerHTML =
      '<div class="lftx-row"><span>Sous-total</span><span>' + money(before) + '</span></div>' +
      (disc > 0
        ? '<div class="lftx-row lftx-disc"><span>Rabais' + (step ? ' ' + step.pct + ' %' : '') + '<span class="lftx-count-detail"> (' + paid + ' article' + (paid > 1 ? 's' : '') + ')</span></span><span>−' + money(disc) + '</span></div>'
        : '') +
      '<div class="lftx-row"><span>Livraison</span><span class="lftx-free">Gratuite</span></div>' +
      '<div class="lftx-row lftx-total"><span>Total</span><span>' + money(total) + '</span></div>' +
      (save > disc && save > 0 ? '<div class="lftx-save">Vous économisez ' + money(save) + ' 🎉</div>' : '');
  };

  P.lftxGiftProduct = async function () {
    if (this.lftxGift) return this.lftxGift;
    try {
      var r = await fetch(ROOT + 'products/' + GIFT_HANDLE + '.js', { headers: { Accept: 'application/json' } });
      this.lftxGift = r.ok ? await r.json() : null;
    } catch (e) { this.lftxGift = null; }
    return this.lftxGift;
  };

  function colorOptions(gift, selectedId) {
    return (gift.variants || []).filter(function (v) { return v.available; }).map(function (v) {
      var name = String(v.title || '').replace(/^\d+\s*/, '');
      name = name.charAt(0).toUpperCase() + name.slice(1);
      return '<option value="' + v.id + '"' + (Number(v.id) === Number(selectedId) ? ' selected' : '') + '>' + name + '</option>';
    }).join('');
  }

  P.lftxDecorate = async function (cart) {
    var D = this.drawer;
    var self = this;

    // Titel
    var title = D.querySelector('.cart-drawer__title');
    if (title) {
      var count = title.querySelector('[data-cart-drawer-count]');
      var label = title.querySelector('.lftx-count');
      if (!label) {
        title.childNodes.forEach(function (n) { if (n.nodeType === 3 && n.textContent.trim()) n.textContent = 'Votre panier '; });
        label = document.createElement('span');
        label.className = 'lftx-count';
        title.appendChild(label);
      }
      var paid = this.lftxPaid(cart);
      var giftQty = (cart.items || []).filter(function (i) { return Number(i.product_id) === GIFT_ID; }).length;
      label.textContent = paid ? '(' + paid + ' article' + (paid > 1 ? 's' : '') + (giftQty ? ' + 1 cadeau' : '') + ')' : '';
      if (count) count.setAttribute('aria-hidden', 'true');
    }

    // Knop + vertrouwensregel
    var btn = D.querySelector('.cart-drawer__checkout-button');
    if (btn && !btn.dataset.lftx) {
      btn.dataset.lftx = '1';
      btn.innerHTML = '<span>🔒 Passer à la caisse</span>';
    }
    var actions = D.querySelector('.cart-drawer__actions');
    if (actions && !D.querySelector('.lftx-trust')) {
      var trust = document.createElement('div');
      trust.className = 'lftx-trust';
      trust.innerHTML =
        '<div><span>🚚</span>' +
          '<span class="lftx-trust-desktop">Livraison gratuite<br>partout au Canada</span>' +
          '<span class="lftx-trust-mobile">Livraison gratuite</span>' +
        '</div>' +
        '<div><span>↩️</span>' +
          '<span class="lftx-trust-desktop">Satisfaite ou<br>remboursée 30 jours</span>' +
          '<span class="lftx-trust-mobile">Retours 30 jours</span>' +
        '</div>' +
        '<div><span>🔒</span>' +
          '<span class="lftx-trust-desktop">Paiement<br>100 % sécurisé</span>' +
          '<span class="lftx-trust-mobile">Paiement sécurisé</span>' +
        '</div>';
      actions.after(trust);
    }

    // "Supprimer" -> "Retirer"
    D.querySelectorAll('.cart-drawer__remove').forEach(function (b) { b.textContent = 'Retirer'; });

    var giftLine = (cart.items || []).find(function (i) { return Number(i.product_id) === GIFT_ID; });
    var offer = D.querySelector('[data-lft-gift-offer]');
    var gift = null;
    if (giftLine || (offer && !offer.hidden)) gift = await this.lftxGiftProduct();

    // Cadeau in het mandje: OFFERT + kleurkeuze, onderaan
    if (giftLine) {
      var li = D.querySelector('[data-cart-item-key="' + CSS.escape(giftLine.key) + '"]');
      if (li) {
        var t = li.querySelector('.cart-drawer__item-title');
        if (t) t.textContent = 'Foulard style cachemire';
        var pr = li.querySelector('.cart-drawer__item-prices');
        if (pr) pr.innerHTML = '<span class="lftx-gift-badge">OFFERT 🎁</span>';
        var v = li.querySelector('.cart-drawer__item-variant');
        if (!v) {
          v = document.createElement('div');
          var top = li.querySelector('.cart-drawer__item-top > div');
          if (top) top.appendChild(v);
        }
        v.className = 'lftx-gift-note';
        v.innerHTML = 'Votre cadeau pour 3 articles.' +
          (gift ? '<br>Couleur : <select data-lftx-gift-color data-key="' + giftLine.key + '">' + colorOptions(gift, giftLine.variant_id) + '</select>' : '');
        var bottom = li.querySelector('.cart-drawer__item-bottom');
        if (bottom) bottom.style.display = 'none';
        if (li.parentElement) li.parentElement.appendChild(li);
      }
    }

    // Cadeau verdiend maar nog niet gekozen: direct in het mandje toevoegen
    if (offer && !offer.hidden && !giftLine) {
      offer.classList.add('lftx-gift-offer');
      offer.innerHTML = '<strong>🎁 Votre foulard offert est débloqué!</strong><br>' +
        (gift ? 'Couleur : <select data-lftx-gift-pick>' + colorOptions(gift) + '</select>' +
          '<button type="button" data-lftx-gift-add>Ajouter mon foulard offert</button>'
          : '<a href="' + ROOT + 'products/' + GIFT_HANDLE + '">Choisir la couleur de mon foulard</a>');
    } else if (offer && giftLine) {
      offer.hidden = true;
    }
  };

  var prevExtras = P.lftExtras;
  P.lftExtras = function (cart) {
    prevExtras.call(this, cart);
    var self = this;
    this.lftxDecorate(cart).catch(function (e) { console.error(e); });
  };

  P.lftxPost = function (path, body) {
    return fetch(ROOT + path, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json', Accept: 'application/json' },
      body: JSON.stringify(body)
    });
  };

  var prevClick = P.handleDrawerClick;
  P.handleDrawerClick = async function (event) {
    var add = event.target.closest('[data-lftx-gift-add]');
    if (add) {
      var pick = this.drawer.querySelector('[data-lftx-gift-pick]');
      if (!pick || !pick.value) return;
      add.disabled = true;
      try {
        await this.lftxPost('cart/add.js', { items: [{ id: Number(pick.value), quantity: 1 }] });
      } catch (e) { console.error(e); }
      await this.refresh();
      return;
    }
    return prevClick.call(this, event);
  };

  var prevChange = P.handleDrawerChange;
  P.handleDrawerChange = async function (event) {
    var sel = event.target.closest && event.target.closest('[data-lftx-gift-color]');
    if (sel) {
      sel.disabled = true;
      try {
        await this.lftxPost('cart/change.js', { id: sel.dataset.key, quantity: 0 });
        await this.lftxPost('cart/add.js', { items: [{ id: Number(sel.value), quantity: 1 }] });
      } catch (e) { console.error(e); }
      await this.refresh();
      return;
    }
    if (event.target.closest && event.target.closest('[data-lftx-gift-pick]')) return;
    return prevChange.call(this, event);
  };
})();
